import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
export const GetPreviewStatsParams = z.object({
    contentSlug: z.string().min(1),
});
export const GetPreviewStatsResponse = z.object({
    missions: z.array(z.object({
        slug: z.string(),
        title: z.string(),
        index: z.number(),
        sentAt: z.null(),
        content: z.object({
            id: z.number(),
            slug: z.string(),
            title: z.string(),
        }),
        week: z.object({
            id: z.number(),
            slug: z.string(),
            title: z.string(),
            index: z.number(),
        }),
        activities: z.array(z.object({
            slug: z.string(),
            title: z.string(),
            activityId: z.number(),
            isCore: z.boolean(),
            instructorReview: z.string().nullable(),
            instructorScore: z.number().nullable(),
            isSubmitted: z.boolean(),
            isCompleted: z.boolean(),
            isSent: z.boolean(),
        })),
    })),
    links: z.array(z.object({
        title: z.string(),
        path: z.string(),
    })),
});
export const getPreviewStatsRoute = {
    version: 1,
    method: 'GET',
    path: '/preview/{contentSlug}/stats',
    name: 'get-stats-preview',
    request: { params: GetPreviewStatsParams },
    responses: {
        200: GetPreviewStatsResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
